import { useEffect } from 'react';
import { setJsonLd, type JsonLdScript } from '@/lib/jsonld';

export function useJsonLd(scripts: JsonLdScript[]): void {
  const serialized = JSON.stringify(scripts);
  useEffect(() => {
    setJsonLd(scripts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);
}